module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAAAoElEQVRIx2PwLZn3+PWHL//pDRgEXev+Kwd3/N1w8Ar9LYbhhOaV/+nlexSLQVg1pPM/PXyPYTG9fI/TYlr7Hq/FtPQ9URbTwvdEW0xt35NsMbV8T5bFio5l/6eqWP+/LiJFNibZ4mDT2P/HJZQospQki6nhS5ItppYvibaY2r4kymJa+BKvxbT0JU6Lae1LDIvp5UsUi90tkl/Ry5fIGACwRleWx3yf/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/cz.png
// module id = 808
// module chunks = 0